export default __webpack_public_path__ + "static/media/chevron-forwardBOX.30ec98bf.svg";